import {
	CAMPAIGNS_SETTINGS_UPDATE_FIELD_VALUE,
	CAMPAIGNS_SETTINGS_ADD_FIELD,
	CAMPAIGNS_SETTINGS_UPDATE_FIELD,
	CAMPAIGNS_SETTINGS_REMOVE_FIELD,
	CAMPAIGNS_SETTINGS_RESET,
} from '../../constants'

const initialState = {
	types: [],
	subjects: [],
	departments: []
};

export const SettingsCampaignsReducer = ( state = initialState, action ) => {
	switch ( action.type ) {
		case CAMPAIGNS_SETTINGS_UPDATE_FIELD_VALUE :
			state = {
				...state,
				[action.payload.settingsProperty]: [
					...state[action.payload.settingsProperty].map((type, key) => {
						if ( key !== parseInt( action.payload.fieldKey ) ) {
							return type;
						}

						return {
							...type,
							[action.payload.name]: action.payload.value
						}
					})
				]
			};

			break;

		case CAMPAIGNS_SETTINGS_UPDATE_FIELD :
			state = {
				...state,
				[action.payload.settingsProperty]: [
					...state[action.payload.settingsProperty].map( ( item, key ) => {
						if ( item.key !== action.payload.childSnap.key ) {
							return item;
						}

						return {
							...item,
							name: action.payload.childSnap.val().name
						}
					})
				]
			};

			break;


		case CAMPAIGNS_SETTINGS_ADD_FIELD :
			const elm = state[action.payload.settingsProperty].find( ( element, index ) => {
				return element.key === action.payload.childSnap.key;
			});

			if ( undefined === elm ) {
				state = {
					...state,
					[action.payload.settingsProperty]: [
						...state[action.payload.settingsProperty],
						{
							name: action.payload.childSnap.val().name,
							key: action.payload.childSnap.key
						}
					]
				};
			}

			break;

		case CAMPAIGNS_SETTINGS_RESET :
			state = initialState;
			break;

		case CAMPAIGNS_SETTINGS_REMOVE_FIELD :
			state = {
				...state,
				[action.payload.settingsProperty]: [
					...state[action.payload.settingsProperty].filter((item, key) => {
						return item.key !== action.payload.childSnap.key;
					})
				]
			};

			break;

		default :
			return state;
	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/settings/campaigns.js